import { css } from '@emotion/css';
import colors from '@/theme/colors';

const styles = {
  container: css`
    display: flex;
    flex-direction: column;
    width: 100%;
    background-color: ${colors.white};
    border-bottom: 1px solid ${colors.silver};
    padding: 16px;
    gap: 12px;
  `,
  headerRow: css`
    display: grid;
    grid-template-columns: 1fr auto 1fr;
    grid-template-areas: 'language title close';
    align-items: center;
    column-gap: 8px;

    @media (max-width: 320px) {
      grid-template-columns: 1fr auto;
      grid-template-areas:
        'title close'
        'language language';
      row-gap: 8px;
    }
  `,
  titleWrapper: css`
    display: flex;
    align-items: center;
    gap: 8px;
    min-width: 0;
    justify-content: center;
    text-align: center;
    grid-area: title;
  `,
  languageWrapper: css`
    display: flex;
    align-items: center;
    justify-content: flex-start;
    grid-area: language;
  `,
  closeButton: css`
    justify-self: flex-end;
    grid-area: close;
  `,
};

export default styles;
